// Recommended tools on the /tools page. Add an entry here for each affiliate link:
// { name, blurb, url, category, code?, edgar? (what Edgar says about it) }
export const AFFILIATE_LINKS = [
  {
    name: "Zip: pay in 4",
    blurb: "Split inventory buys into 4 payments. Get $10 off your first order with my code.",
    url: "https://go.zip.co/aea9b03d",
    category: "Funding",
    code: "FRG4N4",
    edgar: "Zip splits a purchase into 4 payments, and code FRG4N4 gets you $10 off your first order.",
  },
  {
    name: "Klarna Card",
    blurb: "Pay with Klarna anywhere, including at sales and thrift stores. Sign up and start using the card to earn $20.",
    url: "https://l.klarna.com/22XC/invite_YX0vYvUMDJR9Jwva",
    category: "Funding",
    edgar: "The Klarna Card lets you pay with Klarna anywhere, and you earn $20 when you sign up and start using it.",
  },
];
